import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import DespatchParticularReport from '../../common/components/DespatchParticularReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchParticularsReceptacleTypeSelectors';

export function DespatchParticularsReceptacleTypeContainer(props) {
  return (
    <DespatchParticularReport
      reportId={ReportDefinitions.DESPATCH_PARTICULARS_RECEPTACLE_TYPE.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

DespatchParticularsReceptacleTypeContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(DespatchParticularsReceptacleTypeContainer);
